import { render } from "./CreateSharedFS.vue?vue&type=template&id=68e8d4f9&scoped=true"
import script from "./CreateSharedFS.vue?vue&type=script&lang=js"
export * from "./CreateSharedFS.vue?vue&type=script&lang=js"

import "./CreateSharedFS.vue?vue&type=style&index=0&id=68e8d4f9&lang=scss&scoped=true"

import exportComponent from "/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e8d4f9"]])

export default __exports__